export const SMS_CONSENT_VERSION = "customer-care-2026-10-01";

export const SMS_CONSENT_DISCLOSURE =
  "I agree to receive text messages from Repackify about my inquiries, account, orders, and photo requests at the phone number provided. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. Consent is optional and is not a condition of purchase.";
